module.exports = __webpack_public_path__ + "img/one.14f73a7c.png";